<template>
    <div class="grid">
        <div class="field col-12">
            <label for="nome">Nome</label>
            <InputText
                id="nome"
                type="text"
                v-model="nome"
                :class="(fieldsError.some(v => v === 'nome'))?'w-full p-invalid':'w-full'"
                maxlength="50"
            />
        </div>
        <div class="field col-12">
            <label for="descricao">Descrição</label>
            <Textarea
                id="descricao"
                type="text"
                v-model="descricao"
                :class="(fieldsError.some(v => v === 'descricao'))?'w-full p-invalid':'w-full'"
                :autoResize="true"
                rows="2"
            />
        </div>
        <div class="field col-6">
            <label for="limiteMinimo">Qtd. Mínima</label>
            <InputNumber
                id="limiteMinimo"
                v-model="limiteMinimo" 
                :class="(fieldsError.some(v => v === 'limiteMinimo'))?'p-invalid':''"
                :min="0" 
                :max="1000"
                :showButtons="true"
                :allowEmpty="false"
            />
        </div>
        <div class="field col-6">
            <label for="limiteMaximo">Qtd. Máxima</label>
            <InputNumber
                id="limiteMaximo"
                v-model="limiteMaximo" 
                :class="(fieldsError.some(v => v === 'limiteMaximo'))?'p-invalid':''"
                :min="0" 
                :max="1000"
                :showButtons="true"
                :allowEmpty="false"
            />
        </div>
        <div class="field col-12 mb-0 text-right">
            <Button label="Gravar" class="p-button-success p-button-sm" icon="pi pi-check" @click="gravar"></Button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        categoria: Object,
    },
    emits: [
        "save"
    ],
    data() {
        return {
            novo: true,

            // 1.0 Validação
            fieldsError: [],

            // 2.0 Campos Formulário
            nome: "",
            descricao: "",
            limiteMinimo: 0,
            limiteMaximo: 0,
        }
    },
    watch: {

        $props: {
            handler() {
                if(typeof this.categoria == "object" && this.categoria != null) {
                    this.novo = false;

                    this.nome = this.categoria.nome;
                    this.descricao = this.categoria.descricao;
                    this.limiteMinimo = this.categoria.limiteMinimo;
                    this.limiteMaximo = this.categoria.limiteMaximo;
                } else {

                    this.novo = true;

                    this.nome = "";
                    this.descricao = "";
                    this.limiteMinimo = 0;
                    this.limiteMaximo = 0;

                    this.fieldsError = [];

                }
            },
            deep: true,
            immediate: true,
        },

    },
    methods: {

        validateForm: function() {

            this.fieldsError = [];

            if (this.nome == "") {
                this.fieldsError.push("nome");
            }

            if (this.fieldsError.length) {
                this.$toast.add({
                    severity: "error",
                    summary: "ERRO!",
                    detail: "Preencha corretamente todas as informações!",
                    life: 5000,
                });

                return false;
            }

            return true;
        },

        gravar: function() {
            if(this.validateForm()) {
                
                let categoria;

                if(this.novo) {
                    categoria = {};
                } else {
                    categoria = this.$utils.getStdObject(this.categoria);
                }

                categoria.nome = this.nome;
                categoria.descricao = this.descricao;
                categoria.limiteMaximo = this.limiteMaximo;
                categoria.limiteMinimo = this.limiteMinimo;

                this.$emit("save", {value: categoria});

            }
        },

    },
}
</script>
<style scoped>

    :deep(.p-inputnumber-buttons-stacked .p-inputnumber-input) {
        width: 100%;
    }

</style>